<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>
            검색조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>단체</th>
              <td>
                <select v-focus v-model="branchOrgQueryData.branchGb" >
                  <option value="">선택</option>
                  <option v-for="item in branchTypeList" :key="item.code" :label="item.codeNm" :value="item.code"></option>
                </select>
              </td>
              <th>단체명</th>
              <td>
                <input type="text" v-model="branchOrgQueryData.branchNm">
              </td>
              <th>국내/해외</th>
              <td>
                <label><input type="radio" value="1" v-model="branchOrgQueryData.branchLevel" name="branchLevel">국내</label>
                <label><input type="radio" value="2" v-model="branchOrgQueryData.branchLevel" name="branchLevel">해외</label>
              </td>
              <th>지역</th>
              <td>
                <select v-model="branchOrgQueryData.bornCd" >
                  <option value="">선택</option>
                  <option v-for="item in bornCdList" :key="item.code" :label="item.codeNm" :value="item.code"></option>
                </select>
              </td>
              <th>교우직책</th>
              <td colspan="5">
                <label v-for="item in positionCdList" v-bind:key="item.code"><input type="checkbox" :key="item.code" :value="item.code" v-model="checkedPositionCdList">{{item.codeNm}}</label>
              </td>
            </tr>
          </table>

        </md-card-content>

        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="sendQuery"><md-icon>check</md-icon>검 색</md-button>
          <md-button class="md-default md-sm" @click="clearQuery"><md-icon>clear</md-icon>초기화</md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>
      </md-card>


      <!-- 목록 시작 -->
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>
            검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                >
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="branchOrgListGrid"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @response="response"
          ></grid>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import formatter from "@/kuaa/kuaa-formatter";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import kuaaApi from "@/kuaa/kuaa-api";
import axios from "axios";
import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

export default {
  components: {
    grid: Grid
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  created() {
    this.queryBranchTypes();
    this.queryMemberOrgGbList();
    this.queryBornCdTypes();
    this.initGrid();
  },

  data() {
    return {
      // 단체구분 종류
      branchTypeList: [],

      // 교우직책
      positionCdList: [],
      checkedPositionCdList : [],

      // 지역
      bornCdList : [],

      branchOrgQueryData : {
        "branchGb": "", // 단체구분
        "branchNm": "", // 단체명
        "branchLevel" : null, // 국내외
        "positionCd": "", // 교우직책
        "bornCd": "" // 지역
      },

      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },
    };
  },

  methods: {
    /**
     * branch - 공통코드 조회 세팅
     */
    queryBranchTypes() {
      kuaaFnc.fncBranchTypes(null,res => {
        this.branchTypeList = res.data.data.contents;
      });
    },

    /**
     * 교우직책 검색 - 공통코드 조회 세팅
     */
    queryMemberOrgGbList() {
      kuaaFnc.fncPositionCodes(null,res => {
        this.positionCdList = res.data.data.contents;
      });
    },

    /**
     * 지역 검색 - 공통코드 조회 세팅
     */
    queryBornCdTypes() {
      kuaaFnc.fncBornCodes(null,res => {
        this.bornCdList = res.data.data.contents;
      });
    },

    sendQuery (){
      let option = {
        branchGb: this.branchOrgQueryData.branchGb,
        branchNm: this.branchOrgQueryData.branchNm,
        branchLevel: this.branchOrgQueryData.branchLevel,
        positionCd: this.checkedPositionCdList,
        bornCd: this.branchOrgQueryData.bornCd,
        expireDateYn : "N"
      };
      this.$refs.branchOrgListGrid.invoke("readData", 1, option);
    },
    clearQuery (){
      this.branchOrgQueryData.branchGb = "";
      this.branchOrgQueryData.branchNm = "";
      this.branchOrgQueryData.branchLevel = "";
      this.checkedPositionCdList = "";
      this.branchOrgQueryData.bornCd = "";
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_ORG, false, this.pagination);
      this.gridProps['el'] = this.$refs.branchOrgListGrid;
      this.gridProps['columns']= [
        {header: '단체', name: 'branchNm', width:120, align:"center", sortable: true},
        {header: '구분', name: 'branchGbNm', width:60, align:"center", sortable: true},

        {header: '지역', name: 'bornCdNm', width:60, align:"center", sortable: true},
        {header: '국가코드', name: 'nationalCd', width:80, align:"center", sortable: true},
        {header: '국내/해외', name: 'branchLevelNm', width:80, align:"center", sortable: true},
        {header: '교우번호', name: 'memberNo', width:80, align:"center", sortable: true},
        {header: '교우명', name: 'memberHnm', width:80, align:"center", sortable: true},
        {header: '교우직책', name: 'positionNm', width:60, align:"center", sortable: true},
        {header: '성별', name: 'sex', width:50, align:"center", sortable: true},
        {header: '주민번호', name: 'registerNo', width:80, align:"center", sortable: true},
        {header: '핸드폰번호', name: 'cellular', width:110, align:"center", sortable: true},
        {header: '이메일', name: 'EMail', width:140, align:"left", sortable: true},
        {header: '대학코드', name: 'collegeCd', width:60, align:"center", sortable: true},
        {header: '대학명', name: 'collegeNm', width:100, align:"center", sortable: true},
        {header: '학과코드', name: 'classCd', width:60, align:"center", sortable: true},
        {header: '학과명', name: 'classNm', width:120, align:"center", sortable: true},
        {header: '졸업회수', name: 'graduationNo', width:60, align:"right", sortable: true},
        {header: '입학년월', name: 'enterYm', width:80, align:"center", sortable: true},
        {header: '졸업년월', name: 'graduationYm', width:80, align:"center", sortable: true},
        {header: '직종대분류', name: 'workCd1Nm', width:80, align:"center", sortable: true},
        {header: '직종소분류', name: 'workCd2Nm', width:80, align:"center", sortable: true},
        {header: '직장명', name: 'companyNm', width:150, align:"center", sortable: true},
        {header: '학번', name: 'hakbun', width:80, align:"center", sortable: true},
        {header: '상태', name: 'status', width:50, align:"center", sortable: true},
        {header: '우편물발송지', name: 'postplace', width:100, align:"center", sortable: true},
        {header: '미발송구분', name: 'nonpostGb', width:100, align:"center", sortable: true},
        {header: '학력', name: 'degreeNm', width:80, align:"center", sortable: true},
        {header: '웹ID', name: 'webId', width:80, align:"center", sortable: true},
        {header: '자택주소', name: 'homeAddress', width:300, align:"center", sortable: true},
        {header: '직장주소', name: 'officeAddress', width:300, align:"center", sortable: true}
      ];
      this.gridProps['columnOptions'].frozenCount = 9;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.branchOrgListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
    },
    downloadExcel() {

      let option = {
        branchGb: this.branchOrgQueryData.branchGb,
        branchNm: this.branchOrgQueryData.branchNm,
        branchLevel: this.branchOrgQueryData.branchLevel,
        positionCd: this.checkedPositionCdList,
        bornCd: this.branchOrgQueryData.bornCd,
        expireDateYn : "N",
        page: 1,
        perPage: this.pagination.total,
        fileName: '단체임원진'
      };
      kuaaApi.requestFileDownload(
          URL_CONST.GROUP_EXECUTIVE_EXCEL_DOWNLOAD,
          option,
          '단체임원진.xlsx',
          response => {

          }
      );
    }
  }
}
</script>

<style>

</style>